import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers } from "vue";
var _hoisted_1 = {
  "class": "mb-8 text-3xl font-bold"
};
var _hoisted_2 = /*#__PURE__*/_createTextVNode("Contacts");
var _hoisted_3 = /*#__PURE__*/_createElementVNode("span", {
  "class": "text-indigo-400 font-medium"
}, "/", -1);
var _hoisted_4 = /*#__PURE__*/_createTextVNode(" Create ");
var _hoisted_5 = {
  "class": "max-w-3xl bg-white rounded-md shadow overflow-hidden"
};
var _hoisted_6 = {
  "class": "flex flex-wrap -mb-8 -mr-6 p-8"
};
var _hoisted_7 = /*#__PURE__*/_createElementVNode("option", {
  value: null
}, null, -1);
var _hoisted_8 = ["value"];
var _hoisted_9 = /*#__PURE__*/_createElementVNode("option", {
  value: null
}, null, -1);
var _hoisted_10 = /*#__PURE__*/_createElementVNode("option", {
  value: "CA"
}, "Canada", -1);
var _hoisted_11 = /*#__PURE__*/_createElementVNode("option", {
  value: "US"
}, "United States", -1);
var _hoisted_12 = {
  "class": "flex items-center justify-end px-8 py-4 bg-gray-50 border-t border-gray-100"
};
var _hoisted_13 = /*#__PURE__*/_createTextVNode("Create Contact");
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_Head = _resolveComponent("Head");
  var _component_Link = _resolveComponent("Link");
  var _component_text_input = _resolveComponent("text-input");
  var _component_select_input = _resolveComponent("select-input");
  var _component_loading_button = _resolveComponent("loading-button");
  return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_Head, {
    title: "Create Contact"
  }), _createElementVNode("h1", _hoisted_1, [_createVNode(_component_Link, {
    "class": "text-indigo-400 hover:text-indigo-600",
    href: "/contacts"
  }, {
    "default": _withCtx(function () {
      return [_hoisted_2];
    }),
    _: 1
  }), _hoisted_3, _hoisted_4]), _createElementVNode("div", _hoisted_5, [_createElementVNode("form", {
    onSubmit: _cache[10] || (_cache[10] = _withModifiers(function () {
      return $options.store && $options.store.apply($options, arguments);
    }, ["prevent"]))
  }, [_createElementVNode("div", _hoisted_6, [_createVNode(_component_text_input, {
    modelValue: $data.form.first_name,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
      return $data.form.first_name = $event;
    }),
    error: $data.form.errors.first_name,
    "class": "pb-8 pr-6 w-full lg:w-1/2",
    label: "First name"
  }, null, 8, ["modelValue", "error"]), _createVNode(_component_text_input, {
    modelValue: $data.form.last_name,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) {
      return $data.form.last_name = $event;
    }),
    error: $data.form.errors.last_name,
    "class": "pb-8 pr-6 w-full lg:w-1/2",
    label: "Last name"
  }, null, 8, ["modelValue", "error"]), _createVNode(_component_select_input, {
    modelValue: $data.form.organization_id,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) {
      return $data.form.organization_id = $event;
    }),
    error: $data.form.errors.organization_id,
    "class": "pb-8 pr-6 w-full lg:w-1/2",
    label: "Organization"
  }, {
    "default": _withCtx(function () {
      return [_hoisted_7, (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.organizations, function (organization) {
        return _openBlock(), _createElementBlock("option", {
          key: organization.id,
          value: organization.id
        }, _toDisplayString(organization.name), 9, _hoisted_8);
      }), 128))];
    }),
    _: 1
  }, 8, ["modelValue", "error"]), _createVNode(_component_text_input, {
    modelValue: $data.form.email,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = function ($event) {
      return $data.form.email = $event;
    }),
    error: $data.form.errors.email,
    "class": "pb-8 pr-6 w-full lg:w-1/2",
    label: "Email"
  }, null, 8, ["modelValue", "error"]), _createVNode(_component_text_input, {
    modelValue: $data.form.phone,
    "onUpdate:modelValue": _cache[4] || (_cache[4] = function ($event) {
      return $data.form.phone = $event;
    }),
    error: $data.form.errors.phone,
    "class": "pb-8 pr-6 w-full lg:w-1/2",
    label: "Phone"
  }, null, 8, ["modelValue", "error"]), _createVNode(_component_text_input, {
    modelValue: $data.form.address,
    "onUpdate:modelValue": _cache[5] || (_cache[5] = function ($event) {
      return $data.form.address = $event;
    }),
    error: $data.form.errors.address,
    "class": "pb-8 pr-6 w-full lg:w-1/2",
    label: "Address"
  }, null, 8, ["modelValue", "error"]), _createVNode(_component_text_input, {
    modelValue: $data.form.city,
    "onUpdate:modelValue": _cache[6] || (_cache[6] = function ($event) {
      return $data.form.city = $event;
    }),
    error: $data.form.errors.city,
    "class": "pb-8 pr-6 w-full lg:w-1/2",
    label: "City"
  }, null, 8, ["modelValue", "error"]), _createVNode(_component_text_input, {
    modelValue: $data.form.region,
    "onUpdate:modelValue": _cache[7] || (_cache[7] = function ($event) {
      return $data.form.region = $event;
    }),
    error: $data.form.errors.region,
    "class": "pb-8 pr-6 w-full lg:w-1/2",
    label: "Province/State"
  }, null, 8, ["modelValue", "error"]), _createVNode(_component_select_input, {
    modelValue: $data.form.country,
    "onUpdate:modelValue": _cache[8] || (_cache[8] = function ($event) {
      return $data.form.country = $event;
    }),
    error: $data.form.errors.country,
    "class": "pb-8 pr-6 w-full lg:w-1/2",
    label: "Country"
  }, {
    "default": _withCtx(function () {
      return [_hoisted_9, _hoisted_10, _hoisted_11];
    }),
    _: 1
  }, 8, ["modelValue", "error"]), _createVNode(_component_text_input, {
    modelValue: $data.form.postal_code,
    "onUpdate:modelValue": _cache[9] || (_cache[9] = function ($event) {
      return $data.form.postal_code = $event;
    }),
    error: $data.form.errors.postal_code,
    "class": "pb-8 pr-6 w-full lg:w-1/2",
    label: "Postal code"
  }, null, 8, ["modelValue", "error"])]), _createElementVNode("div", _hoisted_12, [_createVNode(_component_loading_button, {
    loading: $data.form.processing,
    "class": "btn-indigo",
    type: "submit"
  }, {
    "default": _withCtx(function () {
      return [_hoisted_13];
    }),
    _: 1
  }, 8, ["loading"])])], 32)])]);
}